import AssetDetails from './AssetDetails'
export default AssetDetails
